import * as React from "react";
const SvgReservations = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4 3.66667V20.3333C4 21.2533 4.74583 22 5.66667 22H6.5V2H5.66667C4.74583 2 4 2.74667 4 3.66667ZM19 2H8.16667V22H19C19.9208 22 20.6667 21.2533 20.6667 20.3333V3.66667C20.6667 2.74667 19.9208 2 19 2ZM17.5417 13.6667H11.2917C10.9483 13.6667 10.6667 13.2917 10.6667 12.8333C10.6667 12.375 10.9483 12 11.2917 12H17.5417C17.885 12 18.1667 12.375 18.1667 12.8333C18.1667 13.2917 17.8858 13.6667 17.5417 13.6667ZM17.5417 9.5H11.2917C10.9483 9.5 10.6667 9.125 10.6667 8.66667C10.6667 8.20833 10.9483 7.83333 11.2917 7.83333H17.5417C17.8858 7.83333 18.1667 8.20833 18.1667 8.66667C18.1667 9.125 17.8858 9.5 17.5417 9.5Z",
	fill: "#1A1919"
}));
export default SvgReservations;
